import { format, parseISO } from "date-fns";
import {
  faCalendar,
  faEye,
  faHeart,
  faTrashCanClock,
  faFolder,
  faCodeCompare,
} from "@fortawesome/pro-light-svg-icons";

export const createMediaInfo = (mediaData, mediaType, t) => {
  const mediaInfo = [];
  if (mediaType !== "asset") {
    mediaInfo.push({
      key: "category",
      translation: "categories.category",
      icon: faFolder,
      value: mediaData[mediaType + "CategoryName"]
        ? mediaData[mediaType + "CategoryName"]
        : null,
    });
  }
  mediaInfo.push(
    {
      key: "publication date",
      translation: "media.publicationDate",
      icon: faCalendar,
      value:
        mediaData.publicationDate &&
        format(new Date(parseISO(mediaData.publicationDate)), "dd-MM-yyyy"),
    },
    {
      key: "expiry date",
      translation: "media.expiryDate",
      icon: faTrashCanClock,
      value:
        mediaData.expiryDate &&
        format(new Date(parseISO(mediaData.expiryDate)), "dd-MM-yyyy"),
    },
    {
      key: "version",
      translation: "media.version",
      icon: faCodeCompare,
      value: mediaData.version ? mediaData.version : null,
    },
    {
      key: "views",
      translation: "media.views",
      icon: faEye,
      value: t
        ? t("media.viewCount", { count: mediaData.views ?? 0 })
        : mediaData.views === 1
          ? "1 view"
          : `${(mediaData.views ?? 0).toLocaleString()} views`,
    },
    {
      key: "popularity",
      translation: "media.popularity",
      icon: faHeart,
      value: t
        ? t("media.likeCount", { count: mediaData.popularity ?? 0 })
        : mediaData.popularity === 1
          ? "1 like"
          : `${mediaData.popularity ?? 0} likes`,
    },
  );
  return mediaInfo;
};